import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
import styles from "./content.module.css";
const Content = forwardRef((props, ref) => {
    const { className, ...otherProps } = props;
    return _jsx("div", { ...otherProps, ref: ref, className: clsx(styles.content, className) });
});
Content.displayName = "List.Item.Content";
export { Content };
